import { useTranslation } from 'react-i18next';

import {
  borderColours,
  type StockStatus,
  textColours
} from '~/domain/stockStatus';
import useRegion from '~/hooks/useRegion';
import {
  formatReleaseDateLarge,
  formatReleaseDateShort,
  getCurrentDateUnix
} from '~/utils/dates';

type Props = {
  releaseDate?: EpochTimeStamp;
  releaseDateFormat?: 'short' | 'long';
  size?: 'LARGE' | 'DEFAULT';
  status?: StockStatus;
};

export default function StockStatusPill({
  status,
  size,
  releaseDate = 0,
  releaseDateFormat = 'short'
}: Props) {
  const { t } = useTranslation();
  const region = useRegion();

  if (!status) return null;

  const formattedReleaseDate =
    releaseDateFormat === 'long'
      ? formatReleaseDateLarge(releaseDate, region)
      : formatReleaseDateShort(releaseDate, region);

  return (
    <span
      data-cy="stock-status"
      className={`rounded-full border font-semibold ${textColours[status]} ${borderColours[status]} ${
        size === 'LARGE'
          ? 'px-4 py-2 text-xs'
          : 'bg-white px-2 py-1 text-[10px]'
      }`}
    >
      {['coming-soon', 'tbc', 'upcoming'].includes(status) &&
      releaseDate > getCurrentDateUnix()
        ? formattedReleaseDate
        : t(status)}
    </span>
  );
}
